module.exports = __webpack_public_path__ + "static/img/VENICE_OAK.239ab4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/VENICE_OAK.jpg
// module id = Ypbz
// module chunks = 0